import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overlay-modal"
}
const _hoisted_2 = { class: "modal-crear" }
const _hoisted_3 = {
  key: 0,
  class: "info"
}
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "seccion" }
const _hoisted_9 = { class: "seccion-head" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "borrador-card"
}
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 0,
  class: "form-group"
}
const _hoisted_16 = { class: "borrador-botones" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 1,
  class: "info"
}
const _hoisted_19 = { class: "pregunta-head" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "indicador-ref"
}
const _hoisted_22 = { class: "ind-nombre" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = ["onUpdate:modelValue", "disabled"]
const _hoisted_27 = ["value"]
const _hoisted_28 = {
  key: 1,
  class: "form-group"
}
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = {
  key: 0,
  class: "error"
}
const _hoisted_31 = { class: "botones" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = ["disabled"]

import { ref, reactive, computed, watch } from 'vue'
import { useGestionInstrumento } from '@/store/GestionInstrumentos'
import { useGestionPreguntas } from '@/store/GestionPreguntas'
import { getCatalogoInstrumentosService } from '@/services/InstrumentosService'
import type { CatalogoInstrumento, ModalidadInstrumento } from '@/interfaces/Instrumetos'

interface PreguntaEditable {
  id_pregunta?: number
  enunciado: string
  tipo_respuesta: string
  opcionesTexto: string
  id_indicador?: number | null
  indicadorNombre?: string | null
  id_pregunta_origen?: number | null
  eliminada: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ModificarFormularioModal',
  props: {
    visible: { type: Boolean },
    idInstrumento: {}
  },
  emits: ["cerrar", "guardado"],
  setup(__props: any, { emit: __emit }) {

/**
 * Edición de un formulario de opinión en borrador.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const props = __props

const emit = __emit

const instrumentoStore = useGestionInstrumento()
const preguntaStore = useGestionPreguntas()

const TIPOS_CON_OPCIONES = ['opcion_unica', 'single_choice', 'multiple_choice', 'casillas']
const TIPOS_PREGUNTA = [
  { valor: 'opcion_unica', etiqueta: 'Opción única' },
  { valor: 'escala_likert', etiqueta: 'Escala Likert' },
  { valor: 'escala_lineal', etiqueta: 'Escala lineal' },
  { valor: 'multiple_choice', etiqueta: 'Casillas' },
  { valor: 'short_text', etiqueta: 'Respuesta corta' },
  { valor: 'long_text', etiqueta: 'Párrafo' }
]

const nombre = ref('')
const herramienta = ref('')
const modalidad = ref<ModalidadInstrumento>('por_pregunta')
const idGrupoInteres = ref<number | null>(null)
const preguntas = ref<PreguntaEditable[]>([])
const catalogo = ref<CatalogoInstrumento>({ herramientas: [], modalidades: [] })
const cargando = ref(false)
const guardando = ref(false)
const error = ref('')

const mostrandoBorrador = ref(false)
const borrador = reactive({ enunciado: '', tipo_respuesta: '', opcionesTexto: '' })

const herramientaActual = computed(() =>
  catalogo.value.herramientas.find(h => h.valor === herramienta.value)
)
const etiquetaHerramienta = computed(() => herramientaActual.value?.etiqueta ?? herramienta.value)
const tiposPreguntaPermitidos = computed(() => herramientaActual.value?.tipos_pregunta ?? [])
const tiposDisponibles = computed(() => {
  const permitidos = tiposPreguntaPermitidos.value
  if (!permitidos.length) return TIPOS_PREGUNTA
  return TIPOS_PREGUNTA.filter(t => permitidos.includes(t.valor))
})

const preguntasVivas = computed(() => preguntas.value.filter(p => !p.eliminada))

function requiereOpciones(tipo: string): boolean {
  return TIPOS_CON_OPCIONES.includes(tipo)
}

function opcionesDe(opcionesTexto: string): string[] {
  return opcionesTexto.split('\n').map(o => o.trim()).filter(Boolean)
}

function abrirBorrador() {
  borrador.enunciado = ''
  borrador.tipo_respuesta = tiposDisponibles.value.length === 1
    ? tiposDisponibles.value[0].valor
    : ''
  borrador.opcionesTexto = ''
  mostrandoBorrador.value = true
}

function confirmarBorrador() {
  preguntas.value.push({
    enunciado: borrador.enunciado,
    tipo_respuesta: borrador.tipo_respuesta,
    opcionesTexto: borrador.opcionesTexto,
    eliminada: false
  })
  mostrandoBorrador.value = false
}

function cerrarBorrador() {
  mostrandoBorrador.value = false
}

function quitarPregunta(i: number) {
  const p = preguntasVivas.value[i]
  if (!p) return
  if (p.id_pregunta) {
    p.eliminada = true
  } else {
    const idx = preguntas.value.indexOf(p)
    if (idx !== -1) preguntas.value.splice(idx, 1)
  }
}

watch(
  () => [props.visible, props.idInstrumento] as const,
  async ([visible, id]) => {
    if (!visible || !id) return
    cargando.value = true
    error.value = ''
    mostrandoBorrador.value = false
    try {
      const [inst, todasPreguntas, cat] = await Promise.all([
        instrumentoStore.getInstrumentoById(id),
        preguntaStore.getPreguntas({ id_instrumento: id }),
        getCatalogoInstrumentosService()
      ])
      catalogo.value = cat
      if (inst) {
        nombre.value = inst.descripcion ?? ''
        herramienta.value = inst.herramienta ?? ''
        modalidad.value = inst.modalidad ?? 'por_pregunta'
        // Grupo del instrumento: se usa al crear preguntas nuevas para que
        // el backend las asocie al Google Form correcto.
        idGrupoInteres.value =
          (inst as any).id_grupo_interes
          ?? inst.grupos_interes?.[0]?.id_grupo_interes
          ?? null
      }
      preguntas.value = (todasPreguntas ?? []).map((p: any) => {
        const ind = Array.isArray(p.indicadores) ? p.indicadores[0] : null
        return {
          id_pregunta:      p.id_pregunta,
          enunciado:        p.enunciado ?? p.pregunta ?? '',
          tipo_respuesta:   p.tipo_respuesta ?? p.tipo ?? '',
          opcionesTexto:    Array.isArray(p.opciones) ? p.opciones.join('\n') : '',
          id_indicador:     p.id_indicador ?? ind?.id_indicador ?? null,
          indicadorNombre:  ind?.enunciado ?? null,
          id_pregunta_origen: p.id_pregunta_origen ?? null,
          eliminada:        false
        }
      })
    } finally {
      cargando.value = false
    }
  },
  { immediate: true }
)

async function guardar() {
  if (!props.idInstrumento) return
  guardando.value = true
  error.value = ''
  try {
    await instrumentoStore.actualizarInstrumento(props.idInstrumento, {
      descripcion: nombre.value.trim(),
      modalidad: modalidad.value
    } as any)

    for (const p of preguntas.value.filter(p => p.eliminada && p.id_pregunta)) {
      await preguntaStore.eliminarPregunta(p.id_pregunta!)
    }

    for (const p of preguntas.value.filter(p => !p.eliminada && p.id_pregunta)) {
      await preguntaStore.actualizarPregunta(p.id_pregunta!, {
        enunciado:     p.enunciado.trim(),
        pregunta:      p.enunciado.trim(),
        tipo_respuesta: p.tipo_respuesta,
        tipo:          p.tipo_respuesta,
        opciones:      requiereOpciones(p.tipo_respuesta) ? opcionesDe(p.opcionesTexto) : []
      })
    }

    let orden = preguntas.value.filter(p => !p.eliminada && p.id_pregunta).length + 1
    for (const p of preguntas.value.filter(p => !p.eliminada && !p.id_pregunta)) {
      await preguntaStore.crearPregunta({
        enunciado:          p.enunciado.trim(),
        pregunta:           p.enunciado.trim(),
        tipo_respuesta:     p.tipo_respuesta,
        tipo:               p.tipo_respuesta,
        opciones:           requiereOpciones(p.tipo_respuesta) ? opcionesDe(p.opcionesTexto) : [],
        id_instrumento:     props.idInstrumento,
        id_indicador:       null,
        id_pregunta_origen: p.id_pregunta_origen ?? null,
        id_grupo_interes:   idGrupoInteres.value,
        orden:              orden++
      })
    }

    emit('guardado', 'Formulario actualizado correctamente.')
    emit('cerrar')
  } catch (e: any) {
    error.value = e?.message ?? 'Error al guardar el formulario.'
  } finally {
    guardando.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[20] || (_cache[20] = _createElementVNode("h4", { class: "modal-titulo" }, "Modificar formulario", -1)),
          (cargando.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Cargando formulario…"))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_4, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", null, "Nombre del formulario", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nombre).value = $event)),
                    type: "text",
                    placeholder: "Nombre del formulario"
                  }, null, 512), [
                    [_vModelText, nombre.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _cache[7] || (_cache[7] = _createElementVNode("label", null, "Tipo de instrumento", -1)),
                  _createElementVNode("input", {
                    value: etiquetaHerramienta.value,
                    type: "text",
                    disabled: "",
                    class: "campo-disabled"
                  }, null, 8, _hoisted_6)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", null, "¿Cómo califica?", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modalidad).value = $event))
                  }, _cache[8] || (_cache[8] = [
                    _createElementVNode("option", { value: "por_pregunta" }, "Cada pregunta califica su indicador", -1),
                    _createElementVNode("option", { value: "formulario_completo" }, "El formulario completo califica un indicador", -1)
                  ]), 512), [
                    [_vModelSelect, modalidad.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[10] || (_cache[10] = _createElementVNode("h5", null, "Preguntas", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm guardar",
                      disabled: mostrandoBorrador.value,
                      onClick: abrirBorrador
                    }, "+ Pregunta", 8, _hoisted_10)
                  ]),
                  (mostrandoBorrador.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", { class: "pregunta-head" }, [
                          _cache[11] || (_cache[11] = _createElementVNode("strong", null, "Nueva pregunta", -1)),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn-quitar",
                            onClick: cerrarBorrador
                          }, "✕")
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _cache[12] || (_cache[12] = _createElementVNode("label", null, "Enunciado", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((borrador.enunciado) = $event)),
                            type: "text",
                            placeholder: "¿En cuánto calificaría…?"
                          }, null, 512), [
                            [_vModelText, borrador.enunciado]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _cache[14] || (_cache[14] = _createElementVNode("label", null, "Tipo de respuesta", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((borrador.tipo_respuesta) = $event))
                          }, [
                            _cache[13] || (_cache[13] = _createElementVNode("option", {
                              value: "",
                              disabled: ""
                            }, "— Seleccionar tipo —", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tiposDisponibles.value, (t) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: t.valor,
                                value: t.valor
                              }, _toDisplayString(t.etiqueta), 9, _hoisted_14))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, borrador.tipo_respuesta]
                          ])
                        ]),
                        (requiereOpciones(borrador.tipo_respuesta))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _cache[15] || (_cache[15] = _createElementVNode("label", null, "Opciones (una por línea, mínimo 2)", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((borrador.opcionesTexto) = $event)),
                                rows: "3",
                                placeholder: "Totalmente de acuerdo\nDe acuerdo\nEn desacuerdo"
                              }, null, 512), [
                                [_vModelText, borrador.opcionesTexto]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-sm guardar",
                            disabled: !borrador.enunciado.trim() || !borrador.tipo_respuesta,
                            onClick: confirmarBorrador
                          }, "Agregar", 8, _hoisted_17)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!preguntasVivas.value.length && !mostrandoBorrador.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_18, "No hay preguntas."))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preguntasVivas.value, (p, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: p.id_pregunta ?? i,
                      class: "pregunta-card"
                    }, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("strong", null, "Pregunta " + _toDisplayString(i + 1), 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn-quitar",
                          onClick: ($event: any) => (quitarPregunta(i))
                        }, "✕", 8, _hoisted_20)
                      ]),
                      (p.indicadorNombre)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _cache[16] || (_cache[16] = _createElementVNode("span", { class: "ind-badge" }, "Indicador", -1)),
                            _createElementVNode("span", _hoisted_22, _toDisplayString(p.indicadorNombre), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_23, [
                        _cache[17] || (_cache[17] = _createElementVNode("label", null, "Enunciado", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((p.enunciado) = $event),
                          type: "text"
                        }, null, 8, _hoisted_24), [
                          [_vModelText, p.enunciado]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _cache[18] || (_cache[18] = _createElementVNode("label", null, "Tipo de respuesta", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": ($event: any) => ((p.tipo_respuesta) = $event),
                          disabled: tiposDisponibles.value.length === 1
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tiposDisponibles.value, (t) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: t.valor,
                              value: t.valor
                            }, _toDisplayString(t.etiqueta), 9, _hoisted_27))
                          }), 128))
                        ], 8, _hoisted_26), [
                          [_vModelSelect, p.tipo_respuesta]
                        ])
                      ]),
                      (requiereOpciones(p.tipo_respuesta))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _cache[19] || (_cache[19] = _createElementVNode("label", null, "Opciones (una por línea, mínimo 2)", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": ($event: any) => ((p.opcionesTexto) = $event),
                              rows: "3"
                            }, null, 8, _hoisted_29), [
                              [_vModelText, p.opcionesTexto]
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                (error.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(error.value), 1))
                  : _createCommentVNode("", true)
              ], 64)),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("button", {
              class: "btn salir",
              disabled: guardando.value,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('cerrar')))
            }, "Cancelar", 8, _hoisted_32),
            _createElementVNode("button", {
              class: "btn guardar",
              disabled: guardando.value || cargando.value || !nombre.value.trim(),
              onClick: guardar
            }, _toDisplayString(guardando.value ? 'Guardando…' : 'Guardar cambios'), 9, _hoisted_33)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})